module.exports = "img/6.70f9d6.webp";